import * as React from "react";

import CircularProgress from "@mui/joy/CircularProgress";
import { User } from "firebase/auth";
import { auth } from "firebase-config";

type AuthContextType = {
  authUser: User | null;
};
export const AuthContext = React.createContext<AuthContextType>({
  authUser: null,
});

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  const [authUser, setAuthUser] = React.useState<User | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setAuthUser(user);

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value: AuthContextType = {
    authUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {loading ? <CircularProgress sx={{ position: "absolute", top: "50%", left: "50%" }} /> : children}
    </AuthContext.Provider>
  );
};
